export default __webpack_public_path__ + "static/media/HUID.19afd89b.png";